import { Theme } from '@mui/material/styles';

export const styles = {
  storiesList: (theme: Theme) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'overlay',
    WebkitOverflowScrolling: 'touch',
    height: `calc(100svh - 80px)`,
    px: '80px',
    [theme.breakpoints.down('md')]: {
      px: '20px',
    },
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.action.disabled,
      borderRadius: '10px',
    },
  }),
  wrapper: (theme: Theme) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > div': {
      maxWidth: '780px',
      width: '100%',
    },
    [theme.breakpoints.down(1920)]: {
      '& > div': {
        maxWidth: '864px',
      },
    },
  }),
};
